export default () => ({
  project: undefined,
  selectedSvgElement: undefined,
  unitInfoRequestFormDetails: undefined,
})
